

const FAQ=()=>{
    return <>FAQ Page</>
    }
export default FAQ